import colors from 'vuetify/lib/util/colors';
<template>
  <div class="pa-3 w-full">
    <div>
      <v-expansion-panels
        class="work-summary-border"
        flat
        light
        accordion
      >
        <v-expansion-panel>
          <v-expansion-panel-header class="justify-between">
            <h4 class="mb-2">
              Today’s Work Summary
            </h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              v-if="workLogs.length == 0"
              class="work-summary-card"
            >
              <p v-if="currentPayRule.current_pay_rule_settings === null">
                Work summary is not available
              </p>
              <p v-else>
                Start your work
              </p>
            </div>
            <div
              v-else
              class="timeline"
            >
              <div
                v-for="(wl, index) in workLogs"
                :key="index"
                class="work-summary-card mb-1"
              >
                <div
                  class="timeline-dot"
                  :class="wl.timesheets.end_time === null ? 'active' : ''"
                />
                <div class="flex flex-column">
                  <span>
                    <font style="font-weight: lighter; font-size: 15px">{{
                      wl.timesheets.pay_item.name
                    }}</font>
                    <div class="float-right badge-worksummary">
                      <span
                        v-if="wl.timesheets.end_time"
                        class="complete"
                      >Completed</span><span
                        v-else
                        class="active"
                      >Active</span>
                    </div>
                  </span>
                  <span>
                    <font
                      style="font-size: 11px; color: grey; font-weight: lighter"
                    >
                      {{
                        wl.timesheets.actual_start_time | convertToLocal
                      }}</font>
                    <font
                      v-if="wl.timesheets.actual_end_time !== null"
                      style="font-size: 11px; color: grey; font-weight: lighter"
                    >
                      -
                      {{ wl.timesheets.actual_end_time | convertToLocal }}</font>
                  </span>
                  <span>
                    <font style="font-weight: lighter; font-size: 12px">{{
                      wl.timesheets.project.name
                    }}</font>
                  </span>
                  <div class="d-flex pt-4">
                    <p class="d-flex flex-column">
                      <span
                        class="card-text"
                      ><font style="font-size: x-small">Completed</font></span>
                      <font style="font-size: 12px; font-weight: bold">
                        {{ formatHours(wl.timesheets.worked_hour) }}
                      </font>
                    </p>
                    <p class="d-flex flex-column ml-15">
                      <span
                        class="card-text"
                      ><font style="font-size: x-small">Threshold</font></span>
                      <font style="font-size: 12px; font-weight: bold">
                        {{ formatHours(wl.timesheets.threshold_hours) }}
                      </font>
                    </p>
                    <p
                      v-if="wl.timesheets.end_time !== null"
                      class="d-flex flex-column ml-15"
                    >
                      <span
                        class="card-text"
                      ><font style="font-size: x-small">Remaining</font></span>
                      <font style="font-size: 12px; font-weight: bold">
                        {{ formatHours(wl.timesheets.remaining_hours) }}
                      </font>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'WorkSummary',
  filters: {
    convertToLocal (stringDatetime) {
      const date = moment(stringDatetime).local();
      const currentYear = moment().year();

      if (date.year() === currentYear) {
        return date.format('Do MMMM, h:mm A');
      } else {
        return date.format('Do MMMM YYYY, h:mm A');
      }
    },
  },
  data: () => ({
    externalId: '',
    showCompleted: true,
  }),
  computed: {
    workLogs () {
      const logs = this.$store.getters['swiftuser/getWorkLogs'];
      return logs;
    },
    currentPayRule () {
      return JSON.parse(localStorage.getItem('userActiveRecord'));
    },
  },
  async mounted () {
    await this.checkLocalStorage();
    if (this.externalId) {
      await this.fetchWorkLogsList(this.externalId);
    }
  },
  methods: {
    checkLocalStorage () {
      const storedData = localStorage.getItem('selectedOrganization');
      if (!storedData) return;
      try {
        const parsed = JSON.parse(storedData);
        if (parsed && parsed.organization && parsed.organization.external_id) {
          this.externalId = parsed.organization.external_id;
        } else {
          console.warn('Invalid selectedOrganization structure:', parsed);
        }
      } catch (err) {
        console.warn('Error parsing selectedOrganization:', err);
      }
    },

    async fetchWorkLogsList () {
      await this.$store.dispatch('swiftuser/fetchWorkLogs', {
        externalId: this.externalId,
      });
    },
    formatHours (timeStr) {
      if (!timeStr) return '-- : --';

      // Handles both "10:30" format and float (10.5)
      let hours = 0;
      let minutes = 0;

      if (typeof timeStr === 'string' && timeStr.includes(':')) {
        const [h, m] = timeStr.split(':').map(Number);
        hours = h;
        minutes = m;
      } else {
        const floatTime = parseFloat(timeStr);
        hours = Math.floor(floatTime);
        minutes = Math.round((floatTime - hours) * 60);
      }

      return `${hours}h ${minutes}m`;
    },
  },
};
</script>
<style scoped>
.work-summary-card {
  border: 1px transparent #ccc;
  border-radius: 5px;
  width: 100% !important;
  position: relative;
  transition: all 0.3s ease-in-out;
}
.work-summary-border {
  border-radius: 5px;
  width: 100% !important;
  position: relative;
  transition: all 0.3s ease-in-out;
}

.w-full {
  width: 100%;
}
.card-text {
  font-size: smaller;
  font-weight: 400;
  color: gray;
}
.flex {
  display: flex;
  justify-content: space-between;
}

.badge-worksummary span {
  font-weight: 400;
  font-size: 10px;

  padding: 2px 6px; /* small padding for a clean badge look */
  border: 1px solid currentColor; /* outline in the text color */
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px; /* rounded corners */
}

.badge-worksummary span.active {
  border-color: #0eca82;
  background-color: #67d6a2;
  color: white;
}

.badge-worksummary span.complete {
  border-color: #73c2fa;
  background-color: #669fd8;
  color: white;
}

.timeline {
  position: relative;
  margin-left: 5px;
  border-left: 2px solid #ddd;
  padding-left: 20px;
}

.timeline-dot {
  position: absolute;
  left: -27px;
  top: -2px;
  width: 10px;
  height: 10px;
  background: #ccc;
  border-radius: 50%;
  z-index: 1;
}

.timeline-dot.active {
  background: #2ecc71;
}
.v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
  flex: none !important;
}
.v-expansion-panel-header {
  justify-content: space-between !important;
  padding: 3px 17px!important;
}
.rotate-icon {
  display: inline-block;
  transition: transform 0.3s ease;
}

.rotate-icon.rotated {
  transform: rotate(180deg);
}
</style>
